export const educationLevelOptions = [
    { label: 'Kindergarten', value: 1 },
    { label: 'Primary School', value: 2 },
    { label: 'Secondary School', value: 3 },
    { label: 'Advanced Secondary School', value: 4 },
    { label: 'College Or University', value: 5 }
  ];
  
  export const MAX_FILE_SIZE_MB = 10;
  export const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png'];